import { useRecoilValue } from 'recoil'

import { $document, $documents } from './selectors'

export function useDocuments() {
  const docs = useRecoilValue($documents)
  return docs
}

export function useDocument(entityName: string, id: string, file: string) {
  const params = new Map()
  params.set('entityName', entityName)
  params.set('id', id)
  params.set('file', file)
  const document = useRecoilValue($document(params))
  return document
}
